/*eslint-disable*/
import DOMPurify from 'dompurify';

export default {
  /**
   * Sanitize a value using DOMPurify.
   * DOMPurify's secure defaults are used (whitelist maintained by security community):
   *   - All on* event handlers blocked
   *   - javascript:/vbscript: URIs blocked
   *   - script/iframe/object/embed/form/svg/math tags blocked
   *   - data-* attributes blocked (not needed for Quill editor output)
   * @param {string} value - The value to sanitize
   * @returns {string} The sanitized value
   */
  sanitizeValue(value) {
    if (!value || typeof value !== 'string') {
      return value;
    }
    return DOMPurify.sanitize(value, { ALLOW_DATA_ATTR: false });
  },

  /**
   * Sanitize search filter payload (searchString and searchField).
   * @param {Object} filterBy - Filter object with searchFilter.searchString and searchFilter.searchField
   * @returns {Object} The sanitized filter object
   */
  sanitizeGroupPayLoad(filterBy) {
    if (filterBy && filterBy.searchFilter) {
      filterBy.searchFilter.searchString = this.sanitizeValue(filterBy.searchFilter.searchString);
      filterBy.searchFilter.searchField = this.sanitizeValue(filterBy.searchFilter.searchField);
    }
    return filterBy;
  },

  /**
   * Sanitize notice payload (FormData with notice_title and notice_desc).
   * @param {FormData} payload - FormData containing notice_title and notice_desc
   * @returns {FormData} The sanitized FormData
   */
  sanitizeNoticePayLoad(payload) {
    const title = this.sanitizeValue(payload.get('notice_title'));
    const desc = this.sanitizeValue(payload.get('notice_desc'));
    payload.set('notice_title', title);
    payload.set('notice_desc', desc);
    return payload;
  },

  /**
   * Legacy method name — delegates to sanitizeValue for backward compatibility.
   * @param {string} nonUsableString - The string to sanitize
   * @returns {string} The sanitized string
   */
  replaceDangerousEvents(nonUsableString) {
    return this.sanitizeValue(nonUsableString);
  },
};
